import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import { bindGa } from '../../../../../helpers/analytics';
import s from './BottomComments.scss';
// import { TOI_LIVE_DOMAIN } from '../../constants';

function getCommentsString(cmt) {
  const elem = document.createElement('div');
  elem.innerHTML = cmt;
  return elem.innerText;
}
class BottomCommmentItem extends React.Component {
  constructor() {
    super();
    this.onVoteUp = this.onVoteUp.bind(this);
    this.onVoteDown = this.onVoteDown.bind(this);
    this.openAddCommentBox = this.openAddCommentBox.bind(this);
    this.handleCommentClick = this.handleCommentClick.bind(this);
  }

  @bindGa({})
  onVoteUp() {
    this.props.putVote(this.props.data, true);
  }

  @bindGa({})
  onVoteDown() {
    this.props.putVote(this.props.data);
  }

  @bindGa({})
  openAddCommentBox(e, id) {
    this.props.openAddCommentBox(id);
    this.props.onClick(id);
  }

  @bindGa({})
  handleCommentClick(e, id) {
    this.props.onClick(id);
  }

  flagHandler = () => {
    setTimeout(() => {
      this.props.flagHandler(this.props.data);
    }, 0);
  };

  render() {
    const {
      A_D_N,
      F_NAME,
      C_T,
      AC_A_C,
      AC_D_C,
      C_A_ID,
      addedNow,
      C_D,
    } = this.props.data;
    const fullName = A_D_N || F_NAME;
    const { data } = this.props;
    const userThumb =
      data.user_detail && data.user_detail.thumb ? data.user_detail.thumb : '';
    const commentStr = getCommentsString(C_T);
    const username =
      data.user_detail && data.user_detail.D_N_U
        ? data.user_detail.D_N_U
        : null;
    const userid =
      data.user_detail && data.user_detail._id ? data.user_detail._id : null;
    const isAuthor = C_A_ID;
    const activePrimeUserPrcArr = [1, 3, 4, 5, 8];
    const primeUser = !!(
      data.user_detail &&
      data.user_detail.U_P_S &&
      activePrimeUserPrcArr.indexOf(parseInt(data.user_detail.U_P_S, 10)) !== -1
    );
    return (
      <div
        className={`${s.innercomment_box} ${isAuthor ? s.aucmt : ''} ${
          this.props.isPrime ? s.prime : ''
        } ${primeUser ? s.primeuser : ''}`}
        onClick={e => this.handleCommentClick(e, this.props.id)}
      >
        <div className="comment_right">
          <div className={s.comment_user_date}>
            <div className={s.user_name_img}>
              <div
                className="user_thumbnail"
                data-ga={`comment-profile_photo-below_as|userid_${userid}`}
              >
                {this.props.renderUserIcon(
                  userThumb,
                  `comment-profile_photo-below_as|userid_${userid}`,
                )}
              </div>
              {username || userid ? (
                <Link
                  to={`http://mytimes.indiatimes.com/profile/${username ||
                    userid}`}
                  className={`name ${s.name}`}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  data-ga={`comment-profile_name-below_as|userid_${userid}`}
                >
                  {fullName}
                </Link>
              ) : (
                <span className={`name ${s.name}`}>{fullName || ''}</span>
              )}
            </div>
            <div className={s.comment_date}>{C_D}</div>
          </div>
          <p
            className="short_comment"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: unescape(
                commentStr && commentStr.length > 150
                  ? `${commentStr.substr(0, 150)}...`
                  : commentStr,
              ),
            }}
          />
          {!addedNow && (
            <div className="footbar clearfix">
              <span
                className="reply_txt"
                data-ga={`comment-reply-below_as|msid_${this.props.msid}`}
                onClick={e => {
                  this.openAddCommentBox(e, this.props.id);
                  e.stopPropagation();
                }}
              >
                Reply
              </span>
              <span
                className="upContainer"
                data-ga={`comment-upvote-below_as|commentid_${this.props.id}`}
                onClick={e => this.onVoteUp(e)}
              >
                <i className="icon uparrow" />
                <span>{AC_A_C}</span>
              </span>
              <span
                className="downContainer"
                data-ga={`comment-downvote-below_as|commentid_${this.props.id}`}
                onClick={e => this.onVoteDown(e)}
              >
                <i className="icon downarrow" />
                <span>{AC_D_C}</span>
              </span>

              {this.props.isPrime && (
                <span className="flagicon" onClick={() => this.flagHandler()} />
              )}
              {!this.props.isPrime && (
                <span className={s.flagComment}>
                  <span
                    onClick={() => this.flagHandler()}
                    className={s.flagicon}
                  >
                    FLAG
                  </span>
                </span>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

BottomCommmentItem.propTypes = {
  renderUserIcon: PropTypes.func.isRequired,
  data: PropTypes.shape({
    A_D_N: PropTypes.string,
    C_A_ID: PropTypes.number,
    F_NAME: PropTypes.string,
    C_T: PropTypes.string,
    AC_A_C: PropTypes.number,
    AC_D_C: PropTypes.number,
    addedNow: PropTypes.number,
  }),
  onClick: PropTypes.func.isRequired,
  isPrime: PropTypes.bool,
  openAddCommentBox: PropTypes.func.isRequired,
  id: PropTypes.number.isRequired,
  putVote: PropTypes.func.isRequired,
  flagHandler: PropTypes.func.isRequired,
  msid: PropTypes.string,
  // isPrivateUser: PropTypes.bool,
};

BottomCommmentItem.defaultProps = {
  data: {
    A_D_N: '',
    F_NAME: '',
    C_T: '',
    AC_A_C: 0,
    AC_D_C: 0,
  },
  isPrime: false,
  msid: '',
  // isPrivateUser: true,
};

export default BottomCommmentItem;
